export const hasMajorPerformanceCaveat = (): boolean => {
  const canvas = document.createElement('canvas');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.append(canvas);
  const gl = canvas.getContext('webgl2', { failIfMajorPerformanceCaveat: true });
  canvas.remove();
  return !gl;
};
